import axios from "axios";

// before a request is made start the nprogress
axios.interceptors.request.use((config) => {
  // eslint-disable-next-line no-undef
  NProgress.start();

  return config;
});

// before a response is returned stop nprogress
axios.interceptors.response.use((response) => {
  //Note: Moved to [afterEach()] event of the rounter.
  // eslint-disable-next-line no-undef
  //NProgress.done()

  return response;
});

export default {
  namespaced: true,
  state: {
    newRequest: {
      id: 0,

      contactName: "",
      contactEmail: "",
      contactPhone: "",
      contactFax: "",

      selectedProviderType: "",
      associatedWithCurrentlyContractedEntity: null,

      selectedPracticeType: "",
      otherPracticeTypeDescription: "",

      selectedFacilityType: "",
      otherFacilityTypeDescription: "",
      serviceAreas: "",

      practitionerName: "",
      businessName: "",
      taxId: "",
      npi: "",
      caqh: "",

      businessPhone: "",
      businessPhoneExtension: "",
      businessFax: "",
      businessEmail: "",

      primarySpecialty: null,
      secondarySpecialty: null,

      primaryAddress: {
        id: 0,
        addressLine1: "",
        suite: "",
        city: "",
        state: "",
        zipcode: "",
        isPrimary: true,
      },

      addresses: [],

      otherPopulationTypeDescription: "",

      selectedLanguages: [],
      otherLanguageDescription: "",

      servesAges_0_2: false,
      servesAges_2_18: false,
      servesAges_18_Plus: false,
      servesAges_Geriatric: false,
      servesAges_Other: false,

      officeHoursMonday: "",
      officeHoursTuesday: "",
      officeHoursWednesday: "",
      officeHoursThursday: "",
      officeHoursFriday: "",
      officeHoursSaturday: "",
      officeHoursSunday: "",

      mhmdApplied: null,
      mhmdApplicationStatus: "",
      mhmdTerminatedDate: "",
      otherIPAPHOAffiliations: "",

      credentialingContactName: "",
      credentialingContactEmail: "",
      credentialingContactPhone: "",
      captchaResponse: "",
    },

    providerTypes: [],

    practiceTypes: [],
    otherPracticeType: {},

    facilityTypes: [],
    otherFacilityType: {},

    specialties: [],

    languages: [],
    otherLanguage: {},

    MHMDApplicationStatuses: [],

    newAddress: {
      id: 0,
      addressLine1: "",
      suite: "",
      city: "",
      state: "",
      zipcode: "",
      isPrimary: false,
    },
  },
  actions: {
    loadAll({ commit }) {
      return axios
        .all([
          axios.get(process.env.VUE_APP_BASE_API_URL + "PracticeType"),
          axios.get(process.env.VUE_APP_BASE_API_URL + "ProviderType"),
          axios.get(process.env.VUE_APP_BASE_API_URL + "FacilityType"),
          axios.get(process.env.VUE_APP_BASE_API_URL + "Specialty"),
          axios.get(process.env.VUE_APP_BASE_API_URL + "Language"),
          axios.get(process.env.VUE_APP_BASE_API_URL + "MHMDApplicationStatus"),
        ])
        .then(
          axios.spread((...responses) => {
            commit("updatePracticeTypes", responses[0].data);
            commit("updateProviderTypes", responses[1].data);
            commit("updateFacilityTypes", responses[2].data);
            commit("updateSpecialties", responses[3].data);
            commit("updateLanguages", responses[4].data);
            commit("updateMHMDApplicationStatuses", responses[5].data);
          })
        )
        .catch((/* error */) => {
          // alert(JSON.stringify(error));
          commit("updateDataError", true, { root: true });
          commit("updateErrorType", "loading-form-data-error", { root: true });
        })
        .then(function() {
          // eslint-disable-next-line no-undef
          NProgress.done();
        });
    },
    loadPracticeTypes({ commit }) {
      axios
        .get(process.env.VUE_APP_BASE_API_URL + "PracticeType")
        .then((result) => commit("updatePracticeTypes", result.data));
    },
    loadProviderTypes({ commit }) {
      axios
        .get(process.env.VUE_APP_BASE_API_URL + "ProviderType")
        .then((result) => commit("updateProviderTypes", result.data));
    },
    loadFacilityTypes({ commit }) {
      axios
        .get(process.env.VUE_APP_BASE_API_URL + "FacilityType")
        .then((result) => commit("updateFacilityTypes", result.data));
    },
    loadSpecialties({ commit }) {
      axios
        .get(process.env.VUE_APP_BASE_API_URL + "Specialty")
        .then((result) => commit("updateSpecialties", result.data));
    },
    loadLanguages({ commit }) {
      axios
        .get(process.env.VUE_APP_BASE_API_URL + "Language")
        .then((result) => commit("updateLanguages", result.data));
    },
    loadMHMDApplicationStatuses({ commit }) {
      axios
        .get(process.env.VUE_APP_BASE_API_URL + "MHMDApplicationStatus")
        .then((result) => commit("updateMHMDApplicationStatuses", result.data));
    },
    addRequest({ commit, state, rootState }) {
      //alert(JSON.stringify(state.newRequest));
      return (
        axios
          .post(process.env.VUE_APP_BASE_API_URL + "Request", state.newRequest)
          .then((result) => {
            // alert(JSON.stringify(result.data));
            commit("updateRequestSubmitCount", 0, { root: true });
            commit("updateRequestAfterSubmission", result.data);
            commit("updateRequestSubmitted", true, { root: true });
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            //alert(JSON.stringify(error));
            // alert("There was an error submitting your form.")

            //Increment the counter
            commit("updateRequestSubmitCount", 1, { root: true });
            if (rootState.requestSubmitCount > 2) {
              commit("updateDataError", true, { root: true });
              commit("updateErrorType", "submitting-form-error", {
                root: true,
              });
            }
          })
          .then(function() {
            // eslint-disable-next-line no-undef
            NProgress.done();
          })
      );
    },
  },
  mutations: {
    updateProviderTypes(state, providerTypes) {
      state.providerTypes = providerTypes;
    },
    updatePracticeTypes(state, practiceTypes) {
      state.practiceTypes = practiceTypes.filter(function(item) {
        return item.Id !== 999;
      });
      state.otherPracticeType = practiceTypes.filter(function(item) {
        return item.Id === 999;
      })[0];
    },
    updateFacilityTypes(state, facilityTypes) {
      state.facilityTypes = facilityTypes.filter(function(item) {
        return item.Id !== 999;
      });
      state.otherFacilityType = facilityTypes.filter(function(item) {
        return item.Id === 999;
      })[0];
    },
    updateSpecialties(state, specialties) {
      state.specialties = specialties;
    },
    updateLanguages(state, languages) {
      state.languages = languages.filter(function(item) {
        return item.Id !== 999;
      });
      state.otherLanguage = languages.filter(function(item) {
        return item.Id === 999;
      })[0];
    },
    updateMHMDApplicationStatuses(state, MHMDApplicationStatuses) {
      state.MHMDApplicationStatuses = MHMDApplicationStatuses;
    },

    resetNewAddress(state) {
      state.newAddress.id = 0;
      state.newAddress.addressLine1 = "";
      state.newAddress.suite = "";
      state.newAddress.city = "";
      state.newAddress.state = "";
      state.newAddress.zipcode = "";
      state.newAddress.isPrimary = false;
    },
    addAddress(state, address) {
      state.newRequest.addresses.push(address);
    },
    loadAddress(state, id) {
      for (let i = 0; i < state.newRequest.addresses.length; i++) {
        if (state.newRequest.addresses[i].id === id) {
          state.newAddress.id = state.newRequest.addresses[i].id;
          state.newAddress.addressLine1 =
            state.newRequest.addresses[i].addressLine1;
          state.newAddress.suite = state.newRequest.addresses[i].suite;
          state.newAddress.city = state.newRequest.addresses[i].city;
          state.newAddress.state = state.newRequest.addresses[i].state;
          state.newAddress.zipcode = state.newRequest.addresses[i].zipcode;
          state.newAddress.isPrimary = state.newRequest.addresses[i].isPrimary;
          break;
        }
      }
    },
    updateAddress(state, address) {
      for (let i = 0; i < state.newRequest.addresses.length; i++) {
        if (state.newRequest.addresses[i].id === address.id) {
          state.newRequest.addresses[i].addressLine1 = address.addressLine1;
          state.newRequest.addresses[i].suite = address.suite;
          state.newRequest.addresses[i].city = address.city;
          state.newRequest.addresses[i].state = address.state;
          state.newRequest.addresses[i].zipcode = address.zipcode;
          state.newRequest.addresses[i].isPrimary = address.isPrimary;
          break;
        }
      }
    },
    deleteAddress(state, id) {
      for (let i = 0; i < state.newRequest.addresses.length; i++) {
        if (state.newRequest.addresses[i].id === id) {
          state.newRequest.addresses.splice(i, 1);
          break;
        }
      }
    },
    updateRequestAfterSubmission(state, submittedRequest) {
      state.newRequest.id = submittedRequest.Id;
    },

    // initializeStateWithData(state) {
    //   state.newRequest.contactName = "Contact Names";
    //   state.newRequest.contactEmail = "david.cantu@memorialhermann.org";
    //   state.newRequest.contactPhone = "(713) 555-1111";
    //   state.newRequest.contactFax = "(713) 555-2222";

    //   state.newRequest.selectedProviderType = "";

    //   state.newRequest.selectedPracticeType = "";
    //   state.newRequest.otherPracticeTypeDescription = "";

    //   state.newRequest.selectedFacilityType = "";
    //   state.newRequest.otherFacilityTypeDescription = "";

    //   state.newRequest.serviceAreas = "";

    //   state.newRequest.practitionerName = "Practitioner Name";

    //   state.newRequest.businessName = "Business Name";
    //   state.newRequest.taxId = "12-3456789";
    //   state.newRequest.npi = "1234567890";
    //   state.newRequest.caqh = "12345678";

    //   state.newRequest.businessPhone = "(713) 555-3333";
    //   state.newRequest.businessPhoneExtension = "123456";
    //   state.newRequest.businessFax = "(713) 555-4444";
    //   state.newRequest.businessEmail = "businessemail@email.com";

    //   state.newRequest.mhmdApplied = "N";
    //   // state.newRequest.mhmdApplicationStatus = 7;
    //   // state.newRequest.mhmdTerminatedDate = '03/03/2020';
    //   // state.newRequest.otherIPAPHOAffiliations = 'Other IPA/PHO Affiliations';

    //   state.newRequest.primarySpecialty = "";
    //   state.newRequest.secondarySpecialty = "";

    //   (state.newRequest.primaryAddress.id = 1),
    //     (state.newRequest.primaryAddress.addressLine1 = "First");
    //   state.newRequest.primaryAddress.suite = "111";
    //   state.newRequest.primaryAddress.city = "Houston";
    //   state.newRequest.primaryAddress.state = "TX";
    //   state.newRequest.primaryAddress.zipcode = "77077";
    //   state.newRequest.primaryAddress.isPrimary = true;

    //   //state.newRequest.addresses.push({id: 2, addressLine1: 'Second', suite: '222', city: 'Katy', state: 'TX', zipcode: '77450', isPrimary: false, });
    //   //state.newRequest.addresses.push({id: 3, addressLine1: 'Third', suite: '333', city: 'Lake Jackson', state: 'TX', zipcode: '77777', isPrimary: false, });

    //   state.newRequest.servesAges_0_2 = false;
    //   state.newRequest.servesAges_2_18 = false;
    //   state.newRequest.servesAges_18_Plus = false;
    //   state.newRequest.servesAges_Geriatric = false;
    //   state.newRequest.servesAges_Other = false;
    //   state.newRequest.otherPopulationTypeDescription = "";

    //   (state.newRequest.selectedLanguages = [2]),
    //     (state.newRequest.otherLanguageDescription = "");

    //   state.newRequest.officeHoursMonday = "9-5";
    //   state.newRequest.officeHoursTuesday = "9-5";
    //   state.newRequest.officeHoursWednesday = "9-2, 4-8";
    //   state.newRequest.officeHoursThursday = "9-5";
    //   state.newRequest.officeHoursFriday = "9-2";
    //   state.newRequest.officeHoursSaturday = "closed";
    //   state.newRequest.officeHoursSunday = "closed";

    //   state.newRequest.credentialingContactName = "Credentialing Contact Name";
    //   state.newRequest.credentialingContactEmail =
    //     "credentialingContactEmail@email.com";
    //   state.newRequest.credentialingContactPhone = "(713) 555-5555";
    // },
  },
  getters: {
    getSecondaryAddresses(state) {
      return state.newRequest.addresses.filter(function(address) {
        return address.isPrimary === false;
      });
    },
  },
};
